import type { HandoffPayload } from "../types";

const HANDOFF_KEY = "aiva_handoff";
const HANDOFF_TTL_MS = 5 * 60 * 1000;

export function writeHandoff(payload: Omit<HandoffPayload, "timestamp">): void {
  try {
    const value: HandoffPayload = { ...payload, timestamp: Date.now() };
    localStorage.setItem(HANDOFF_KEY, JSON.stringify(value));
  } catch {
    /* localStorage unavailable — ignore */
  }
}

export function readHandoff(): HandoffPayload | null {
  try {
    const raw = localStorage.getItem(HANDOFF_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as HandoffPayload;
    if (!parsed.timestamp || Date.now() - parsed.timestamp > HANDOFF_TTL_MS) {
      localStorage.removeItem(HANDOFF_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function consumeHandoff(): HandoffPayload | null {
  const value = readHandoff();
  if (value) {
    try {
      localStorage.removeItem(HANDOFF_KEY);
    } catch {
      /* ignore */
    }
  }
  return value;
}

export function clearHandoff(): void {
  try {
    localStorage.removeItem(HANDOFF_KEY);
  } catch {
    /* ignore */
  }
}
